export default __webpack_public_path__ + "static/media/pi.2911477a.jpg";